import { FC } from 'react';
import { MessageSquare, Shield } from 'lucide-react';
import { Button } from "@/components/ui/button";
import { useNavigate } from 'react-router-dom';
import { useSidebar } from '@/components/ui/sidebar';

export const SidebarFooter: FC = () => {
  const { setOpenMobile, isMobile } = useSidebar();
  const navigate = useNavigate();

  const handleWhatsAppContact = () => {
    window.open('https://wa.me/59898801814', '_blank');
  };

  const handleControlPanel = () => {
    if (isMobile) {
      setOpenMobile(false);
    }
    navigate('/control', { replace: true });
  };

  return (
    <div className="flex flex-col gap-4 p-4 bg-white md:bg-transparent border-t border-gray-200">
      <Button
        onClick={handleControlPanel}
        className="w-full bg-[#E9EDF7] hover:bg-[#4318FF] text-[#2B3674] hover:text-white flex items-center gap-2 justify-center transition-all"
      >
        <Shield className="h-5 w-5" />
        <span>Panel de Control</span>
      </Button>
      
      <Button
        onClick={handleWhatsAppContact}
        className="w-full bg-[#E6FAF5] hover:bg-[#01B574] text-[#2B3674] hover:text-white flex items-center gap-2 justify-center transition-all"
      >
        <MessageSquare className="h-5 w-5" />
        <span>Contactar Soporte</span>
      </Button>
    </div>
  );
};